import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export interface DocumentLayoutState {
  showMapAndDetails: boolean;
  showLeftPanel: boolean;
}

export const LEFT_PANEL_MIN_WIDTH_PX = 180;
export const LEFT_PANEL_MAX_WIDTH_PX = 480;
export const LEFT_PANEL_DEFAULT_WIDTH_PX = 385;

const STORAGE_KEY = 'structuring-document-layout';
const DEFAULT: DocumentLayoutState = {
  showMapAndDetails: true,
  showLeftPanel: true,
};

const storage = createJSONStorage<DocumentLayoutState>(() => sessionStorage);

export const documentLayoutAtom = atomWithStorage<DocumentLayoutState>(
  STORAGE_KEY,
  DEFAULT,
  storage
);

export const toggleMapAndDetailsAtom = atom(null, (get, set) => {
  const current = get(documentLayoutAtom);
  set(documentLayoutAtom, {
    ...current,
    showMapAndDetails: !current.showMapAndDetails,
  });
});

export const toggleLeftPanelAtom = atom(null, (get, set) => {
  const current = get(documentLayoutAtom);
  set(documentLayoutAtom, {
    ...current,
    showLeftPanel: !current.showLeftPanel,
  });
});

export const leftPanelWidthAtom = atom<number>(LEFT_PANEL_DEFAULT_WIDTH_PX);
